<template>
  <div id="blue-circle">
    <div class="circle">
      <h3 class="title"><span class="iconfont">&#xe6ce;</span>圈子</h3>
      <p class="line"></p>
      <div class="add">
        <ul class="list">
          <li
            class="list-item"
            v-for="item of list"
            :key="item.id"
            @click="handleBtnClick(item)"
          >
            <span class="iconfont">&#xe612;</span>
            <p class="item-title">{{ item.name }}</p>
            <button class="addBtn">+ 加入</button>
          </li>
        </ul>
        <div class="qr-code">
          <img :src="qrCode" alt="" />
          <h3 class="group-name">{{ groupName }}</h3>
        </div>
      </div>
    </div>
    <Calculator></Calculator>
  </div>
</template>

<script>
import Calculator from "./Calculator";
export default {
  name: "BlueCircle",
  components: {
    Calculator
  },
  data() {
    return {
      qrCode: "",
      groupName: "",
      list: [
        {
          id: 1,
          name: "癌症",
          qrCode: require("../../../../assets/images/qrcode.jpg"),
          groupName: "一号群"
        },
        {
          id: 2,
          name: "儿童疾病",
          qrCode:
            "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1563300030768&di=cb1b4f5e18d1d94b34590707afedb4c0&imgtype=0&src=http%3A%2F%2Fimgs.focus.cn%2Fupload%2Fcs%2F11091%2Fb_110904724.jpg",
          groupName: "二号群"
        },
        {
          id: 3,
          name: "罕见类疾病",
          qrCode:
            "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1563300030767&di=49b33b7cd3f02ad98a5180eaae343c9e&imgtype=0&src=http%3A%2F%2Fmmbiz.qpic.cn%2Fmmbiz_png%2FWib2s4yycfVfzhIx6pNVWjibhibf5jsIFWWN5VLKnUibmaEXvPUkz1yz6by69AFoTMLJ9ujekUxa5JqDRiaGX4ibaRvg%2F640%3Fwx_fmt%3Dpng",
          groupName: "三号群"
        },
        {
          id: 4,
          name: "心血管疾病",
          qrCode:
            "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1563300030766&di=bd74f85247cfc2a9a8a96a733f4812ec&imgtype=0&src=http%3A%2F%2Fcdn.huodongxing.com%2Ffile%2F20150803%2F11124E7F31F55E74056438634AA559E8D6%2F30822040603074726.jpg%3Fauth_key%3D1529756474-0-0-ed7c3c88c68330c3ede9ed3851b4c535",
          groupName: "四号群"
        },
        {
          id: 5,
          name: "肾脏疾病",
          qrCode:
            "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1563300030765&di=70b69037aa581d08e9b3d01d2d6f61d3&imgtype=0&src=http%3A%2F%2Fimg1.efu.com.cn%2Fupfile%2Fnews%2Fcommonly%2F2014%2F2014-05-15%2Fdhh12_455540545554052.jpg",
          groupName: "五号群"
        }
      ]
    };
  },
  mounted() {
    this.qrCode = this.list[0].qrCode;
    this.groupName = this.list[0].groupName;
  },
  methods: {
    handleBtnClick(item) {
      this.qrCode = item.qrCode;
      this.groupName = item.groupName;
    }
  }
};
</script>

<style lang="scss" scoped>
#blue-circle {
  flex: 1;
  height: 65%;
  width: 100%;
  margin-left: 24px;
  .circle {
    height: 280px;
    /*background: #4a9cee;*/
    .title {
      line-height: 60px;
      margin-left: 20px;
      font-size: 22px;
      color: #4e4e4e;
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
        font-weight: 500;
      }
    }
    .line {
      width: 100%;
      border-bottom: 2px solid #e6e6e6;
    }
    .add {
      display: flex;
      .list {
        .list-item {
          display: flex;
          align-items: center;
          margin: 15px 0;
          .iconfont {
            color: #3496e3;
            font-size: 20px;
          }
          .item-title {
            width: 180px;
          }
          .addBtn {
            border: 1px solid #3496e3;
            color: #168eeb;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }
      .qr-code {
        text-align: center;
        margin: 40px auto 0;
        img {
          width: 110px;
          height: 110px;
        }
        .group-name {
          font-size: 18px;
          color: #4c4c4c;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
